import React from 'react';
import { PlmProgramDetailView } from './plmProgram-detail-view';
import { useInjectableComponents } from '../../../system/services/injectableComponentsManager';
import { useIsSmallScreen } from '../../../system/SystemMediaQueriesProvider';

export const PlmProgramDetail: React.FC = () => {
  const { setTitle, setTitlePath } = useInjectableComponents();
  const isSmall = useIsSmallScreen();

  React.useEffect(() => {
    setTitle(isSmall ? 'PLM Program' : 'Peak Load Management Program');
    setTitlePath('/plmPrograms');

    return () => {
      setTitle(undefined);
      setTitlePath(undefined);
    };
  }, [setTitle, setTitlePath, isSmall]);

  return <PlmProgramDetailView />;
};
